import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const ConfirmedBrands = ({ brands = [] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  if (!brands.length) {
    return (
      <div className="">
        <p className="mt-4 text-center text-gray-400 text-sm sm:text-base">
          {t('event_detail.no_brands_confirmed')}
        </p>
      </div>
    );
  }

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    const amount = container.clientWidth * 0.6;
    container.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  };

  return (
    <div className="relative">
      {brands.length > 4 && (
        <div className="absolute -top-1 right-0 flex gap-2 z-10">
          <button
            type="button"
            onClick={() => scroll('left')}
            className="w-9 h-9 rounded-full border border-gray-300 bg-white flex items-center justify-center hover:bg-gray-100 transition"
            aria-label="Scroll left"
          >
            <ChevronLeftIcon className="w-5 h-5 text-gray-600" />
          </button>
          <button
            type="button"
            onClick={() => scroll('right')}
            className="w-9 h-9 rounded-full border border-gray-300 bg-white flex items-center justify-center hover:bg-gray-100 transition"
            aria-label="Scroll right"
          >
            <ChevronRightIcon className="w-5 h-5 text-gray-600" />
          </button>
        </div>
      )}

      <div
        ref={scrollRef}
        className="mt-2 flex gap-5 overflow-x-auto scroll-smooth py-2"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {brands.map((b, idx) => {
          const src = b.logo || b.avatar || b.image;
          const label = b.username || b.name;
          const slug = b.slug;

          return (
            <button
              type="button"
              key={b.id ?? `${label || 'brand'}-${idx}`}
              className="shrink-0 w-28 h-28 sm:w-36 sm:h-36 rounded-full overflow-hidden bg-white ring-1 ring-gray-200 shadow-sm hover:shadow-md transition focus:outline-none focus:ring-2 focus:ring-yellow-500"
              title={label}
              onClick={() => slug && navigate(`/brands/${slug}`)}
              disabled={!slug}
              style={{ cursor: slug ? 'pointer' : 'default' }}
            >
              <img
                src={src}
                alt={label || 'brand'}
                className="w-full h-full object-cover"
                loading="lazy"
                draggable={false}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ConfirmedBrands;
